<template>
<div>
   <div class="container-fluid mt--6 filter-show">
      <div class="abs-btn-grp-arbs">
        <div>
          <div class="d-flex align-items-center justify-content-end gap-2 flex-wrap">
                  <form @submit.prevent="" class="d-inline-block justify-content-center headSearch mr-2 mb-3">
        <i @click="searchOffer()" style="margin:0px"  class="fas fa-search active cursor-pointer" aria-hidden="true"></i>
        <input v-on:keyup.enter="searchOffer" v-model.trim="searchValue"  @keypress="isAlphanumeric($event)" class="form-control form-control-sm" type="text" placeholder="Search cusip" aria-label="Search">
        <i v-if="searchValue" @click="clearSearch()" class="fas fa-times-circle cursor-pointer"></i>
      </form>
       <div >
      <button v-if="!feedType" :disabled="loading || arbsUploadStatus == 'INPROGRESS'" @click="suspendAll('munis')" type="button" class="btn btn-danger btn-sm ml-2"><i class="fas fa-pause-circle"></i> SUSPEND MUNIS </button>
      <button v-if="feedType" :disabled="loading || arbsUploadStatus == 'INPROGRESS'" @click="suspendAll('corps')" type="button" class="btn btn-danger btn-sm ml-2"><i class="fas fa-pause-circle"></i> SUSPEND CORPS</button>

            </div>
    
          </div>
        </div>
        <div class="d-flex justify-content-end">
          <div class="mr-3 mt-1 text-white">
            <label class="form-label text-white">Munis Only?</label>
            <toggle-button
              :sync="true"
              v-model="feedType"
              :color="{
                checked: '#CE93D8',
                unchecked: '#2dce89',
                disabled: '#CCCCCC'
              }"
              @change="feedTypeChanged()"
            />
            <label class="form-label text-white">Corps Only?</label>
          </div>
 <div class="recap" v-if="totalArbsInEcns">
        <span style="color: #0084cc;">Recap : </span>
        <span v-for="(value, key) in totalArbsInEcns" :key="key">
          {{ key }}: {{ value }}
        </span>
        <span 
          @click="getFeedRecap()" 
          class="fas fa-sync-alt  cursor-pointer" 
          v-bind:class="{ 'fa-spin': countLoading }"
          data-toggle="tooltip" 
          data-placement="left" 
          title="Refresh count"
          aria-hidden="true"></span>
      </div>
        </div>
      </div>
    </div>
  <div class="container-fluid filter-show mt-4">
          <div class="card w-100 p-2 mb-2  d-inline-block">
            <div class="d-flex justify-content-between">
              <h5 class="ml-3">Filters</h5>
              <span class="btn btn-link" @click="showFilters = !showFilters">
                <i class="fa" v-bind:class="[showFilters ? 'fa-angle-up' : 'fa-angle-down']" ></i> {{showFilters ? 'Hide' : 'Show'}} Filters
              </span>
            </div>
            <div class="row" v-if="showFilters">
              <div class="col-lg-12">
                <form class="row">
                  <div class="col-md-6 col-lg-3">
                    <label>Filter By Offer Status</label>
                     <multiselect 
                      v-model="offerStatus" 
                      placeholder="Select Offer Status" 
                      label="name" 
                      track-by="code" 
                      :options="options" 
                      :multiple="false" 
                      :limit="3"></multiselect>
                  </div>
                  <div class="col-md-6 col-lg-3" v-if="this.isAdmin || this.isEditor">
                    <label>Filter By Trader</label>
                     <multiselect 
                        v-model="filterTrader" 
                        placeholder="Select traders" 
                        label="firstName" 
                        track-by="traderId"
                        :options="traderList"  
                        :multiple="false" 
                        :limit="3"  ></multiselect>
                  </div>
                  <div class="col-md-6 col-lg-3 mt-4" >
                    <label>Show forwarded arbs?</label>
                    <toggle-button :sync="true" v-model="showForwardedArbsOnly" @change="getOfferList()"/>
                 </div> 
                  <div class="col-md-6 col-lg-3" v-if="showForwardedArbsOnly">
                    <label>Forwarded by</label>
                     <multiselect 
                        v-model="forwardedBy" 
                        placeholder="Select user" 
                        label="firstName" 
                        track-by="traderId"
                        :options="userList"  
                        :multiple="true" 
                        :limit="3"  ></multiselect>
                  </div>
                  
                  <div class="col-md-6 col-lg-3 text-center">
                    <button @click="clearFilter()" type="button" class="btn btn-secondary rounded mt-3">Clear</button>
                    <button @click="getOfferList('isFilterApplied')" type="button" class="btn btn-primary rounded mt-3">Filter</button>
                  </div>
                </form>
              </div>
            </div>
          </div>
  </div>
  <div class="container-fluid">
   
      <div class="row xsOnly">
        <div class="col-xl-12">
          <div class="card scrollbar vh-75" id="scroll">
            <div class="table-responsive">
                <!-- <h4 class="d-inline-block py-4">All Offerings
                  <div class="liveOffer">
                    Live Offers : <span class="badge">{{liveOffersCount ? liveOffersCount : 0}}</span> 
                    <span 
                      @click="getOfferStatus()" 
                      style="margin:5px" 
                      class="fas fa-sync-alt  cursor-pointer" 
                      v-bind:class="{ 'fa-spin': countLoading }"
                      data-toggle="tooltip" 
                      data-placement="left" 
                      title="Refresh count"
                      aria-hidden="true"></span> 
                  </div>
                </h4>
                  <div class="input-group col-md-2 tbl-sch rounded" style="top:23px">
                      <input v-on:keyup.enter="searchOffer" @keypress="isAlphanumeric($event)" type="text" v-model.trim="searchValue" class="form-control rounded" placeholder="Search" />
                      <span v-if="searchValue" @click="clearSearch()" class="cursor-pointer input-group-text border-0"><i class="fas fa-times"></i></span>
                      <span @click="searchOffer()" class="cursor-pointer input-group-search border-0"><i class="fas fa-search"></i></span>
                  </div>
                  <div class="col-md-3 tbl-filter">
                    <label>Filter By Offer Status</label>
                    <multiselect 
                    v-model="offerStatus" 
                    placeholder="Select Offer Status" 
                    label="name" 
                    @input="removeDuplicates" 
                    track-by="code" 
                    :options="options" 
                    :multiple="true" 
                    :limit="3"  ></multiselect>
                    <button @click="searchOffer()" type="button" class="flt-btn btn btn-success"><i class="fas fa-filter"></i></button>
                  </div>
                  <div class="col-md-3 tbl-filter">
                    <label>Filter By Holding Status</label>
                    <multiselect 
                      v-model="holdingStatus" 
                      placeholder="Select Status" 
                      label="name" 
                      track-by="code" 
                      :options="holdingOptions" 
                      :multiple="true" 
                      :limit="2" ></multiselect>
                    <button @click="searchOffer()" type="button" class="flt-btn btn btn-success"><i class="fas fa-filter"></i></button>
                  </div> -->
                  <table class="table align-items-center table-flush table-hover bidtbl imstbl">
                      <thead class="thead-light psticky">
                      <tr >
                          <th 
                          scope="col" 
                          class="sort"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cusip'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cusip'  ? 'sort-desc' : '']"  
                          @click="sort('cusip')">CUSIP/DESC</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'quantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'quantity'  ? 'sort-desc' : '']"  
                          @click="sort('quantity')">QTY</th>
                          <th
                            scope="col"
                            class="sort text-center"
                            v-bind:class="[sortOrder == 'ASC' && sortColumn == 'executedQuantity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'executedQuantity'  ? 'sort-desc' : '']"  
                            @click="sort('executedQuantity')">Fill/Rem
                            </th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'price'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'price'  ? 'sort-desc' : '']"  
                          @click="sort('price')">ARB PRICE</th>
                          <!-- <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'offerValidity'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'offerValidity'  ? 'sort-desc' : '']"  
                          @click="sort('offerValidity')">OFFER <br> VALIDITY</th> -->
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'status'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'status'  ? 'sort-desc' : '']"  
                          @click="sort('status')">OFFER <br>  STATUS</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'offerType'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'offerType'  ? 'sort-desc' : '']"  
                          @click="sort('offerType')">OFFER <br>  TYPE</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'coupon'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'coupon'  ? 'sort-desc' : '']"  
                          @click="sort('coupon')">COUPON</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'cost'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'cost'  ? 'sort-desc' : '']"  
                          @click="sort('cost')">ARB COST</th>
                          <th
                          scope="col"
                          class="sort text-center">TMC<br>Status
                          </th>
                          <th
                          scope="col"
                          class="sort text-center">TWR<br>Status
                          </th>
                          <th
                          scope="col"
                          class="sort text-center">KBP<br>Status
                          </th>
                          <th
                            scope="col"
                            class="sort text-left">MKTX<br>Status
                            </th>
                          <th
                          scope="col"
                          class="sort text-center">SOURCE
                          </th>
                          <th
                          scope="col"
                          class="sort text-center">ECN's
                          </th>
                          <!-- <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'yield'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'yield'  ? 'sort-desc' : '']"  
                          @click="sort('yield')">YIELD</th> -->
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'yieldSpread'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'yieldSpread'  ? 'sort-desc' : '']"  
                          @click="sort('yieldSpread')">SPREAD</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'balance'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'balance'  ? 'sort-desc' : '']"  
                          @click="sort('balance')">BAL/MIN/INC</th>
                          
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'firstName'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'firstName'  ? 'sort-desc' : '']"  
                          @click="sort('traderName')">TRADER</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-if="offerStatus.code == 'SUSPENDED'"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'suspendedAt'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'suspendedAt'  ? 'sort-desc' : '']"  
                          @click="sort('suspendedAt')">SUSPENDED AT</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-if="offerStatus.code == 'DELETED'"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'deletedAt'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'deletedAt'  ? 'sort-desc' : '']"  
                          @click="sort('deletedAt')">DELETED AT</th>
                          <th 
                          scope="col" 
                          class="sort text-center"
                          v-if="offerStatus.code == 'DELETED'"
                          v-bind:class="[sortOrder == 'ASC' && sortColumn == 'deletedReason'  ? 'sort-asc' : '',sortOrder == 'DESC' && sortColumn == 'deletedReason'  ? 'sort-desc' : '']"  
                          @click="sort('deletedReason')">DELETED REASON</th>
                          <th scope="col" class="text-center">Action</th>
                      </tr>
                      </thead>
                      <tbody class="list">
                      <tr v-if="totalRows == 0 && !loading">
                          <td><p class="nodata">No data available</p>
                          </td>
                      </tr>
                      <tr v-for="offer in offerings" :key="offer.id" @click="getOfferDetails(offer)" v-bind:class="{'active-row': offer.isActive}">
                          <td>
                              <span class="cusips"  v-bind:class="'cusip-'+offer.cusipColour">{{offer.cusipVal}}</span>
                              <span class="desc" v-bind:class="'cusipDes-'+offer.cusipDescColour">{{offer.cusipDescription}}</span>
                          </td>
                          <td class="text-center">
                              <span>{{offer.quantity}}</span><br>
                          </td>
                           <td class="text-center">
                              <span class="mr-3 d-inline-block">Fill<br><span class="text-danger d-block">{{offer.executedQuantity || 0}}</span></span>
                              <span class="d-inline-block">REM<br><span class="text-success d-block">{{(offer.quantity - offer.executedQuantity) || 0}}</span></span>
                          </td>
                          <td class="text-center">
                              <span>{{offer.price | currency }}</span><br>
                          </td>
                          <!-- <td class="text-center">
                              <span>{{offer.offerValidity}}</span><br>
                          </td> -->
                          <td class="text-center">
                              <span>{{offer.status}}</span><br>
                          </td>
                          <td class="text-center">
                              <span>{{offer.offerType}}</span><br>
                          </td>
                          
                          <td class="text-center">
                              <span>{{offer.coupon |  percent(3)}}</span><br>
                          </td>
                          <td class="text-center">
                              <span>{{offer.cost | currency}}</span><br>
                          </td>
                          <td class="text-center">
                              <span class="border rounded-pill px-2 py-1 mr-2" v-bind:title="getEcnStatus(offer.tmcStatus).message" v-bind:class="getEcnStatus(offer.tmcStatus).className">{{offer.tmcStatus}}</span>
                              <!-- <span class="text-primary">{{offer.tmcprice ? offer.tmcprice.toFixed(3) : 0}}</span> -->
                          </td>
                          <td class="text-center">
                              <span class="border rounded-pill px-2 py-1 mr-2" v-bind:title="getEcnStatus(offer.twdStatus).message" v-bind:class="getEcnStatus(offer.twdStatus).className">{{offer.twdStatus}}</span>
              
                          </td>
                          <td class="text-center">
                              <span class="border rounded-pill px-2 py-1 mr-2" v-bind:title="getEcnStatus(offer.ibpStatus).message"  v-bind:class="getEcnStatus(offer.ibpStatus).className">{{offer.ibpStatus}}</span>
                              <!-- <span class="text-primary">{{offer.ibpprice ? offer.ibpprice.toFixed(3) : 0}}</span> -->
                          </td>
                          <td class="text-left">
                                    <span class="border rounded-pill px-2 py-1 mr-2" v-bind:title="getEcnStatus(offer.mktxStatus).message"  v-bind:class="getEcnStatus(offer.mktxStatus).className">{{offer.mktxStatus}}</span>
                                    
                                </td>
                          <td class="text-center">
                              <span>{{offer.offerSource.toString()}}</span>
                          </td>
                          <td class="text-center">
                              <span>{{offer.ecns.toString()}}</span>
                          </td>
                          
                          <!-- <td class="text-center">
                              <span>{{offer.yield}}</span>
                          </td> -->
                          <td class="text-center">
                              <span>{{(offer.price - offer.cost).toFixed(3)}}</span>
                          </td>
                          <td class="text-center">
                              <span>{{offer.balance}} - {{offer.minimum}} - {{offer.incrementVal}}</span>
                          </td>
                          <td class="text-center">
                              <span>{{offer.firstName}} {{offer.lastName}}</span>
                          </td>
                          <td  v-if="offerStatus.code == 'SUSPENDED'" class="text-center">
                              <span>{{offer.suspendedAt ? moment.utc(offer.suspendedAt).local().format('h:mm:ss a') : 'N/A'}}</span>
                          </td>
                          <td v-if="offerStatus.code == 'DELETED'" class="text-center">
                              <span>{{offer.deletedAt ? moment.utc(offer.deletedAt).local().format('h:mm:ss a') : 'N/A'}}</span>
                          </td>
                          <td v-if="offerStatus.code == 'DELETED'" class="text-center">
                            <button @click="showDeletedReason(offer.deletedReason)" title="Deleted Reason" class="btn ibtn btn-outline-danger"><i class="far fa-comments"></i></button>
                              <!-- <span data-toggle="tooltip" data-placement="left"  v-bind:title='offer.deletedReason' >{{offer.deletedReason | truncate(20, '...')}}</span> -->
                          </td>
                          <td class="text-center">
                            <a v-if="offer.status != 'DELETED' && offer.status != 'SUSPENDED'"  @click="editOffer(offer)" class="btn ibtn grn"><i class="fas fa-pencil-alt"></i></a>
                            <a v-if="offer.status == 'SUSPENDED'"  @click="deleteOffer(offer)" class="btn ibtn btn-outline-danger "><i class="fas fa-trash-alt"></i></a>
                            <button @click="openCustomerDetailsModal(offer)" class="btn ibtn btn-outline-primary" title="Customers"><i class="far fa-user"></i></button>
                            <div class="dropdown" v-if="offer.status != 'DELETED' && offer.status != 'SUSPENDED'">
                                <button class="btn ibtn blk dropdown-toggle" type="button" id="dropdownMenu2" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                    <i class="fas fa-ellipsis-v"></i>
                                </button>
                                <div  class="dropdown-menu" aria-labelledby="dropdownMenu2">
                                    <button @click="deleteOffer(offer)"  class="dropdown-item del" type="button">Delete</button>
                                    <button v-if="settings.isSendToEcn && offer.status == 'ECN_SENT'" @click="suspendOffer(offer)"  class="dropdown-item del" type="button">Suspend</button>
                                    <button v-if="settings.isSendToEcn && offer.status == 'NEW' || offer.status == 'ECN_SENT' || offer.status == 'SUSPENDED'"  @click="reuploadOffer(offer)"  class="dropdown-item del" type="button">Reupload</button>
                                    <!-- <button @click="toggleChangeTraderModal();selectedOffer = offer"  class="dropdown-item" type="button">Change Trader</button> -->

                                </div>
                            </div>
                          </td>
                          </tr>
                      </tbody>
                      <div v-if="loading" class="loader"><img src="@/assets/img/loader.svg" alt=""/></div>

                  </table>
                  <!-- Pagination-->
                  <b-pagination
                      class="mt-4"
                      :total-rows="totalRows"
                      v-model="currentPage"
                      :per-page="perPage"
                      @input="getOfferList(currentPage)"
                  ></b-pagination>
                  <div class="total-records">
                      <span>Total Records : {{totalRows}}</span>
                  </div>
            </div>
          </div>
        </div>
      </div> 
      <add-offer
            v-if="editOfferModalOpen"
            v-bind:offerCusip="offerCusip"  
            v-bind:selectedOffer="selectedOffer"  
            v-bind:mode="'EDIT'" 
            v-bind:platform="'ARBS'"   
            @close="editOfferModalClose()">
      </add-offer>
  <customer-details v-if="customerDetailModalOpen" v-bind:offerData="selectedOffer"   @close="customerDetailModalOpen = false" />   
  <ChangeTrader v-if="changeTraderModalOpen" v-bind:offerData="selectedOffer"   @close="toggleChangeTraderModal()" />
  
  </div>  
</div>    
</template>
<script>
import config from "@/config";
import authService from "@/authService";
import stateConstants from "@/stateConstants";
import ecnStatus from "@/ecnStatus";
import addOffer from "../ims-offering/ImsAddOfferModal"
import customerDetails from "../ims-offering/ImsOfferingCutomerDetails"
import ChangeTrader from "../ims-offering/ImsChangeTraderModal"

export default {
  name: "imsAllOfferListComponent",
  components : {
    addOffer,
    customerDetails,
    ChangeTrader
  },
  data() {
    return {
        accessToken: null,
        config: config,
        loading : false,
        currentPage: 1,
        perPage: 25,
        searchValue : "",
        totalRows : 0,
        selectedCusip : "",
        sortColumn: "cusip",
        sortOrder: "DESC",
        stateConstants: stateConstants,
        offerings:[],
        editOfferModalOpen : false,
        offerCusip : null,
        customerDetailModalOpen : false,
        selectedOffer : {},
        offerStatus: { name: 'Ecn Sent', code: 'ECN_SENT' },
        options: [
          // { name: 'New', code: 'NEW' },
          // { name: 'Hold', code: 'HOLD' },
          { name: 'Suspended', code: 'SUSPENDED' },
          { name: 'Deleted', code: 'DELETED' },
          { name: 'Ecn Sent', code: 'ECN_SENT' },
          // { name: 'Ecn to be sent', code: 'TO_BE_SEND_ECN' },
          // { name: 'Hold on holding upload', code: 'HOLD_ON_HOLDINGS_UPLOAD' },

        ],
        holdingStatus: [],
        holdingOptions: [
          { name: 'Bought Date Different', code: 'BOUGHT_DATE_DIFFERENT' },
          { name: 'Qty increased', code: 'HOLDING_QTY_INCREASED' },
          { name: 'Qty Decreased', code: 'HOLDING_QTY_DECREASED' }
        ],
        ecnStatus : ecnStatus,
        isAdmin: false,
        isEditor : false,
        isTrader : false,
        liveOffersCount : 0,
        settings : {isSendToEcn : true},
        countLoading : false,
        showFilters : false,
        arbsUploadStatus : localStorage.getItem("ARBSUPLOADSTATUS"),
        changeTraderModalOpen : false,
        filterTrader : null,
        traderList : [],
        isUserTest : authService.getUser().id === 1,
        purgeDate : null,
        forwardedBy : [],
        userList : [],
        showForwardedArbsOnly : false,
        totalArbsInEcns : null,
        feedType: localStorage.getItem('ARBSFEEDTYPE')
        ? localStorage.getItem('ARBSFEEDTYPE') == 'MUNIS'
          ? false
          : true
        : false // false for munis, true for corps



    };
  },
  methods: {
     feedTypeChanged () {
      if (!this.feedType) {
        localStorage.setItem('ARBSFEEDTYPE', 'MUNIS')
      } else {
        localStorage.setItem('ARBSFEEDTYPE', 'CORPS')
      }
      this.getOfferList('isFilterApplied')
      this.getFeedRecap()
    },
    showDeletedReason(reason){
      this.$fire({titile:"Deleted Reason",type: 'info',html: reason})

    },
    toggleChangeTraderModal(){
      this.changeTraderModalOpen = !this.changeTraderModalOpen;
      if(!this.changeTraderModalOpen){
        this.getOfferList();
      }
    },
    editOfferModalClose(){
      this.editOfferModalOpen = false;
      this.getOfferList();

    },
    removeDuplicates(data){
      this.offerStatus = data.filter((role, index, self) =>
        index === self.findIndex((t) => (
          t.code === role.code && t.name === role.name
        ))
      )
    },
    getEcnStatus(ecnStatus){
      //console.log(this.ecnStatus)
      var ecnData = this.ecnStatus.find(x => x.status === ecnStatus);
      if(ecnData){
        var className = ecnData.type == 'error'  ? 'border-warning text-error' : 'border-success text-success';
        return  { className : className ,status : ecnStatus,message : ecnData.message }
      }else{
        return  { className : 'border-success text-success' ,status : ecnStatus, message : "" }
      }
      
    },
    searchOffer(){
     // console.log("d",this.offerStatus.map((status) => {return status.code}).toString())
      this.getOfferList(); 
    },
    clearFilter(){
      this.offerStatus = { name: 'Ecn Sent', code: 'ECN_SENT' };
      this.getOfferList(); 

    },
    clearSearch(){
      this.searchValue = "";
      this.getOfferList(); 
    },
    sort(column){
      this.sortColumn = column;
      this.sortOrder =  this.sortOrder == 'ASC' ? this.sortOrder = "DESC" : this.sortOrder = 'ASC';
      this.getOfferList();
    },
    getStateName(id){
      return id ? this.stateConstants.find(x => x.id === id).short : 'N/A';
    },
    getOfferDetails(offerSelected){
      this.offerings.forEach(function(offer) {
        offer.isActive = false;
      });
      offerSelected.isActive = true;
    },
    getOfferList(isFilterApplied) {
      this.loading = true;
      let ecnStatus = "";
      let deletedFromDate = ""
      if(!this.offerStatus){
        ecnStatus = "ECN_SENT";
      }else{
        ecnStatus = this.offerStatus.code;
      }
      if(this.offerStatus.code == 'SUSPENDED' && isFilterApplied){
        this.sortColumn = "suspendedAt";
      }else if(this.offerStatus.code == 'DELETED' && isFilterApplied){
        this.sortColumn = "deletedAt";
       
      }else if(this.offerStatus.code == 'ECN_SENT' && isFilterApplied){
        this.sortColumn = "cusip";
      }

      if(this.purgeDate && this.offerStatus.code == 'DELETED'){
          deletedFromDate = this.purgeDate;
        }

      const auth = {
        headers: {'org-token' : authService.getOrgToken() }
      };
      let filterByCognito = authService.getUser().cognitoSub;
      // if(this.isAdmin || this.isEditor){
      //   filterByCognito = "";
      // }
      if(this.filterTrader){
        filterByCognito = this.filterTrader.cognitoSub
      }
      this.$http
        .get(
          config.baseUrlBidSide +
            "/offer/listall?page=" +
            this.currentPage +
            "&size=" +
            this.perPage +
            "&search=" +
            this.searchValue +
            "&status="+
            ecnStatus +
            "&sortColumn=" +
            this.sortColumn +
            "&sortOrder=" +
            this.sortOrder+
            "&cusips="+
            "&accountMappingIds="+
            "&holdingUploadStatus="+
            this.holdingStatus.map((status) => {return status.code}).toString()+
            "&createSource=ARBS_FEED_IBP,ARBS_FEED_TMC,ARBS_FEED_TWD,ARBS_FEED_MKTX"+
            "&cognitoSub=" +
            (filterByCognito)+
            "&deletedFromDate=" +deletedFromDate+
            "&showForwardedOnly="+
            this.showForwardedArbsOnly+
            "&forwardedBy="+
            (this.forwardedBy.length ? this.forwardedBy.map((e) => {return e.cognitoSub}).toString()  : "")+
             '&isMuni=' +
            (!this.feedType ? 'true' : 'false'),
            auth

        )
        .then(result => {
          //console.log(result);
          this.totalRows = result.data.pageInfo.totalElements;
          result.data.content.forEach(function(cusip) {
           cusip.isActive = false;
          });
           this.offerings = result.data.content;
           this.loading = false;
        })
        .catch(e => {
          console.log("Error", e);
          //self.loading = false;
        });
    },
    editOffer(offer){
      this.selectedOffer = {...offer};
      let cusip = {};
          cusip.cusip = offer.cusipVal;
          cusip.maturityDate = offer.maturityDate;
          cusip.callDate = offer.callDate;
          cusip.coupon = offer.coupon;
          cusip.stateId = offer.stateId;
          cusip.id = offer.cusipId;
          cusip.offeringTypeId = offer.offeringTypeId;
      this.offerCusip = cusip;
      this.editOfferModalOpen = true;
    },
    // searchCusip(cusip){
    //     this.loading = true;
    //     const auth = {
    //         headers: { 'org-token' : authService.getOrgToken() }
    //     };
    //     this.$http
    //     .get(
    //       config.baseUrlBidSide +
    //         "/cusip/list?page=1&status=ACTIVE,BLOCKED&sortColumn=cusip&sortOrder=ASC&type=OFFER"+
    //         "&cusip=" +
    //         cusip,
    //         auth
    //     )
    //     .then(result => {
    //       if(result.data.content.length > 0){
    //         this.offerCusip = result.data.content[0];
    //         this.editOfferModalOpen = true;
    //       }
    //       this.loading = false;
    //     })

    //  },
     openCustomerDetailsModal(offer){
       this.selectedOffer = offer;
       this.customerDetailModalOpen = true;   
     },
     movetomsrb(offer){
      var message = "Are you sure you want to move this offer to MSRB?";
      this.$confirm(message,"Move to MSRB","",{confirmButtonText:"Yes",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          let data = {
                  "id":offer.id,
                  "status":"MSRB",
                  "updateByCognitoSub" : authService.getUser().cognitoSub

              }
          this.$http
          .put(config.baseUrlBidSide + "/offer/status",data,auth)
          .then(() => {
            this.loading = false;              
            this.getOfferList();
           
          })
          .catch(() => {
              this.loading = false;              
          });
      });
     },
    suspendOffer(offer){
      var message = "Are you sure you want to suspend this offer?";
      this.$confirm(message,"Suspend offer","question",{confirmButtonText:"Suspend",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          let data = {
                  "offerId":offer.id,
                  "cognitoSub": authService.getUser().cognitoSub
              }
          this.$http
          .post(config.baseUrlBidSide + "/offer/suspend-offer",data,auth)
          .then(() => {
            this.loading = false;              
            this.getOfferList();
          })
          .catch(() => {
              this.loading = false;              
          });
      });
     },
     reuploadOffer(offer){
      var message = "Are you sure you want to reupload this offer?";
      this.$confirm(message,"Reupload offer","",{confirmButtonText:"Reupload",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          let data = {
                  "offerId":offer.id,
                  "cognitoSub": authService.getUser().cognitoSub
              }
          this.$http
          .post(config.baseUrlBidSide + "/offer/reupload-offer",data,auth)
          .then((result) => {
            this.loading = false;
            if(result.data.show){
              this.sentToEcnModalOpen = true;
              this.offerSenttoEcn = result.data
            }else{
              this.$alert("Offer reupload successfully","","success");
            }              
            this.getOfferList();
          })
          .catch(() => {
              this.loading = false;              
          });
      });
     },
     deleteOffer(offer){
      var message = "Are you sure you want to delete this offer?";
      this.$confirm(message,"Delete offer","question",{confirmButtonText:"Delete",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          let data = {
                  "id":offer.id,
                  "status":"DELETED",
                  "updateByCognitoSub" : authService.getUser().cognitoSub
              }
          this.$http
          .put(config.baseUrlBidSide + "/offer/status",data,auth)
          .then(() => {
            this.loading = false;              
            this.getOfferList();
           
          })
          .catch(() => {
              this.loading = false;              
          });
      });
     },
     getOfferStatus(){
      this.countLoading = true;
      let url = "/offer/stats";
      const auth = {
          headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
      .get(
        config.baseUrlBidSide + url,
          auth
      )
      .then(result => {
        this.liveOffersCount = result.data.live;
        this.countLoading = false;
      })

    },
    getSettings(){
        const auth = {
            headers: { 'org-token' : authService.getOrgToken() }
        };
        this.$http
        .get(
           config.baseUrlBidSide +
            "/organization/bid-settings?type=OFFER",
            auth
        )
        .then(result => {
          this.settings = result.data;

        })        
    },
    suspendAll(type){
      var message = `Are you sure you want to suspend all ${type == 'munis' ? 'Municipal' : 'Corporates'} offers?`;
      let filterByCognito = authService.getUser().cognitoSub;
      // if(this.isAdmin || this.isEditor){
      //   filterByCognito = "";
      // }
      this.$confirm(message,"Suspend","question",{confirmButtonText:"Suspend",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          this.$http
          .post(config.baseUrlAutoBidder + "/offer/arbs-feed-suspend-all",{
            "cognitoSub":filterByCognito,
            "showForwardedOnly":this.showForwardedArbsOnly,
            "forwardedBy" : this.forwardedBy.map((e) => {return e.cognitoSub}),
            "isMuni": type == 'munis' ? true : false

          },auth)
          .then(() => {
            this.loading = false;  
            localStorage.setItem("ARBSUPLOADSTATUS", "INPROGRESS");
            this.arbsUploadStatus = localStorage.getItem("ARBSUPLOADSTATUS")
            this.$alert("Suspend in progress.","","success");            
          })
          .catch(() => {
              this.loading = false;              
          });
      });  
    },
    reuploadAll(){
      var message = "Are you sure you want to upload all offers?";
      let filterByCognito = authService.getUser().cognitoSub;
      // if(this.isAdmin || this.isEditor){
      //   filterByCognito = "";
      // }
      this.$confirm(message,"Upload","question",{confirmButtonText:"Upload",cancelButtonText : "No"}).then(() => {
          this.loading = true;
          const auth = {
              headers: { 'org-token' : authService.getOrgToken()  }
          };
          this.$http
          .put(config.baseUrlAutoBidder + "/offer/sendtoecn-arbs-feed",{
            "cognitoSub":filterByCognito,
            "showForwardedOnly":this.showForwardedArbsOnly,
            "forwardedBy" : this.forwardedBy.map((e) => {return e.cognitoSub})
          },auth)
          .then(() => {
            this.loading = false;  
            localStorage.setItem("ARBSUPLOADSTATUS", "INPROGRESS");
            this.arbsUploadStatus = localStorage.getItem("ARBSUPLOADSTATUS")
            this.$alert("Reupload in progress.","","success");            
          })
          .catch(() => {
              this.loading = false;              
          });
      });  
    },
    checkArbsFileuploadDetail(){
       this.loading = true;
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .get(
            config.baseUrlBidSide +
                "/offer/arbs-fileupload-detail?cognitoSub="+authService.getUser().cognitoSub,
                auth
            )
            .then(() => {
              this.reuploadAll()
              this.loading = false;
            })
            .catch(e => {
                console.log(e);
                this.loading = false;
            });
    },
    getUserSetting(){
        this.loading = true;
        const auth = {
            headers: {'org-token' : authService.getOrgToken() }
        };
        this.$http
            .get(
            config.baseUrlBidSide +
                "/tradebook/setting-list?cognitoSub="+authService.getUser().cognitoSub,
                auth
            )
            .then(result => {
                this.userSettings = result.data;
                this.userSettings.forEach(element => {
                  if(element.setting == "PAGINATION_COUNT"){
                    this.perPage = element.value != 0 ? element.value : 25;
                  }

                });
                this.getOfferList();
                // this.loading = false;
            })
            .catch(e => {
                console.log(e);
            });
    },
    getTraderList(){
      const auth = {
        headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/user/list?page=1&size=1000&search=&status=ACTIVE&sortColumn=firstName&sortOrder=ASC&group=Drl-Trader",
            auth
        )
        .then(result => {
          this.traderList = result.data.content;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getFeedRecap(){
      this.countLoading = true;
      const auth = {
        headers: { 'org-token' : authService.getOrgToken() }
      };
      let filterByCognito = authService.getUser().cognitoSub;
      if(this.isAdmin || this.isEditor){
        filterByCognito = "";
      }
      this.$http
        .get(
           config.baseUrlAutoBidder +
            "/arbs-feed/recap?cognitoSub="+filterByCognito + '&isMuni=' + !this.feedType,
            auth
        )
        .then(result => {
          this.totalArbsInEcns = result.data.totalArbsInEcns;
          this.countLoading = false;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getPurgeDetails(){
      const auth = {
        headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/arbs/purge-details?cognitoSub="+authService.getUser().cognitoSub,
            auth
        )
        .then(result => {
          this.purgeDate = result.data.latestPurgeDate;
        })
        .catch(e => {
          console.log(e);
        });
    },
    getUserList(){
      const auth = {
        headers: { 'org-token' : authService.getOrgToken() }
      };
      this.$http
        .get(
           config.baseUrlBidSide +
            "/user/list?page=1&size=1000&search=&status=&sortColumn=firstName&sortOrder=ASC&group&showForwarders=true&cognitoSub="+authService.getUser().cognitoSub,
            auth
        )
        .then(result => {
          this.userList = result.data.content;
        })
        .catch(e => {
          console.log(e);
        });
    },
  },
  mounted() {
    this.getUserSetting();
    // this.getOfferStatus();
    this.getSettings();
    this.getTraderList();
    this.getPurgeDetails();
    this.getUserList();
    this.getFeedRecap();
    this.$root.$on("ARBS_OFFER_UPDATED", () => {
      this.getOfferList();
      this.arbsUploadStatus = null;

    });
    this.$root.$on("ARBSUPLOADCOMPLETED", () => {
      this.arbsUploadStatus = null;

    });
    this.$cognitoAuth.getUserGroup((err, role) => {
        if (err) {
          console.log("accessToken is not found", err);
        } else {
          //console.log(role)
          this.tenantName = role[0].split("-")[0];
          var roleArray = role.map(item => {
            return  item.split("-")[1];
          })
          roleArray.includes('Admin')   ? this.isAdmin  = true : this.isAdmin  = false;
          roleArray.includes('Trader')  ? this.isTrader = true : this.isTrader = false;
          roleArray.includes('Editor')  ? this.isEditor = true : this.isEditor = false;
          //roleArray.includes('SuperAdmin')  ? this.isSuperAdmin = true : this.isSuperAdmin = false;
        }
        //console.log("isa",this.isAdmin);
      });
      //this.$cognitoAuth.getUserRoles((err, role) => console.log(role));

  },
  beforeDestroy() {
    this.$root.$off("ARBS_OFFER_UPDATED");
    this.$root.$off("ARBSUPLOADCOMPLETED");

  }
};
</script>
<style scoped>
.recap{
  padding: 6px;
  background-color: white;
  height: 31px;
  /* margin: 5px 20px; */
  border-radius: 19px;
}
.recap span{
  padding: 6px;
  position: relative;
  bottom: 4px;
}
.abs-btn-grp-arbs {
  position: absolute;
  top: 55px;
  right: 110px;
}


.abs-btn-grp-arbs input {
    background: transparent;
    border-radius: 0;
    border: 0;
    border-bottom: 1px solid #fff;
    color: #FFF;
    font-weight: 400;
    width: 100%;
    padding: 0 0 0 20px;
    height: 27px;
}

.abs-btn-grp-arbs .btn-danger {
   border-radius:6px; color: #fff
}
.abs-btn-grp-arbs .btn-danger i {
  color: #fff
}
</style>